import { type Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import type { ApiResponse } from '@shared/http/types';

import type { Profile } from './models';
import type { ProfileDto } from './dto';
import { mapProfileFromDto } from './mappers';

import { buildApiEndpoint } from '@core/http';
import { mapDataNonNull } from '@shared/http/operators';

@Injectable({
  providedIn: 'root',
})
export class ProfileRepository {
  private readonly http = inject(HttpClient);

  getProfile(): Observable<Profile> {
    return this.http.get<ApiResponse<ProfileDto>>(buildApiEndpoint('profile')).pipe(mapDataNonNull(mapProfileFromDto));
  }
}
